let springTransform = require('./transform/spring/transform');
let summerTransform = require('./transform/summer/transform');
let autumnTransform = require('./transform/autumn/transform');
let winterTransform = require('./transform/winter/transform');
let listTransform = require('./transform/list/transform');
let contentTransform = require('./transform/content/transform');

module.exports = {
    ...springTransform,
    ...summerTransform,
    ...autumnTransform,
    ...winterTransform,
    ...listTransform,
    ...contentTransform,
};
